<template>
  <div class="noticeInfo" :style="isPage ? ' height: 100vh; max-height: 100vh' : ''" @scroll.self.stop="onScroll">
    <bloom-header v-if="model === 1"/>
    <div style="height: 24px"></div>
    <div class="content">
      <div class="content_header" v-if="isPage" style="padding: 20px 0">
        <div class="content_header_h cursor" @click="toList" v-if="model === 1">{{$t('flowMessage12')}}></div>
        <div class="content_header_title">{{noticeTitle}}</div>
      </div>
      <div class="content_box">
        <div v-for="(item, index) in content" :key="JSON.stringify(item) + index">
          <Course :data='item' :ref="index"></Course>
        </div>
        <div style="height: 32px"></div>
      </div>
    </div>
    <div class="footerBtn" :style="isPage? 'position: relative' : ''">
      <div class="btn" @click="goUrl">{{customWebConfig.btnText || $t('comfirm')}}</div>
      <div class="listTip" v-if="!isPage && noticeNo > 0">
        <span>{{$t('flowMessage13')}}{{noticeNo}}{{$t('flowMessage14')}}</span>
        <span class="color" @click="toNotice">{{$t('flowMessage23')}}</span>
      </div>
    </div>
  </div>
</template>

<script>

import BloomHeader from '@public/header'
import Course from '@/components/module/course/main.vue'          // 课程

export default {
  props: {
    model: {
      type: Number,
      default: 1 // 1 是页面展示 2 是弹窗展示
    },
    noticeId: {
      type: String,
      default: '' //
    },
    topicId: {
      type: String,
      default: '' //
    },
    noticeNo: {
      type: Number,
      default: 0 // 未读公告
    }
  },
  data () {
    return {
      content: [],
      noticeTitle: '',
      isPage: false,
      customWebConfig: {

      }
    }
  },
  methods: {
    onScroll (e) {
      console.log(e, 'e')
      e.preventDefault()
    },
    goUrl () {
      if (this.customWebConfig && this.customWebConfig.btnUrl) {
        window.open(this.customWebConfig.btnUrl, '_blank')
      } else {
        // 没有链接关闭窗口
        this.$emit('close')
      }
    },
    // 去公告列表
    toNotice () {
      this.$emit('close')
      this.$router.push({
        path: '/teamMessage',
        query: {
          topicId: this.$route.params.seasonId,
          contestId: this.$route.query.contestId,
          type: 1
        }
      })
      // this.$router.push({
      //   path: '/teamMessage',
      //   query: {
      //     topicId: this.$route.params.seasonId
      //   }
      // })
    },
    // 获取详情
    getInfo () {
      let data
      if (this.isPage) {
        data = {
          noticeId: this.$route.query.noticeId,
          topicId: this.$route.query.topicId
        }
      } else {
        data = {
          noticeId: this.noticeId,
          topicId: this.topicId
        }
      }
      this.$api.post('COMMON_NOTICE_INFO', data, res => {
        // console.log()
        if (!res.data.publishTime) {
          this.$message.error('暂无当前公告阅读权限')
          location.reload()
          return
        }
        this.noticeTitle = res.data.noticeTitle || ''
        let obj = {
          title: this.noticeTitle,
          time: res.data.publishTime
        }
        this.$emit('getdialogTitle', obj)
        this.content = res.data.noticeContent ? JSON.parse(res.data.noticeContent) : []
        this.customWebConfig = res.data.customWebConfig ? JSON.parse(res.data.customWebConfig) : {}
      })
    },
    // 去列表页
    toList () {
      this.$router.go(-1)
      // this.$router.push({
      //   path: '/teamMessage',
      //   query: {
      //     topicId: this.$route.query.topicId
      //   }
      // })
    },
    // 初始化
    init () {
      // if (this.$route.query.topicId && this.$route.query.topicId) {
      //   this.isPage = true
      // }
      this.getInfo()
    }
  },
  created () {
    this.init()
  },
  components: {
    BloomHeader,
    Course
  }
}
</script>

<style lang="scss" scoped>
.noticeInfo{
  background: #F2F2F6;
  max-height: 663px;
  overflow-y: scroll;
  position: relative;
   &::-webkit-scrollbar {
   /*滚动条整体样式*/
     display: block;
     height: 6px;  /*高宽分别对应横竖滚动条的尺寸*/
     width: 8px;
   }
   &::-webkit-scrollbar-corner{
     display: none;
   }
   &::-webkit-scrollbar-thumb {
     /*滚动条里面小方块*/
     width: 4px!important;
     background: #B9B9C5;
     border-radius: 8px;
   }
  .footerBtn{
    position: sticky;
    height: 87px;
    width: 100%;
    background: #F2F2F6;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.06);
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    .listTip {
      position: absolute;
      bottom: 30px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #9499A4;
      right: 42px;
      .color {
        color: #296BFF;
        cursor: pointer;
      }
    }
    .btn {
      min-width: 100px;
      height: 39px;
      background: #296BFF;
      border-radius: 20px;
      padding: 0 10px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      text-align: center;
      line-height: 39px;
      cursor: pointer;
    }
  }
  .content{
    width: 1000px;
    background: #FFFFFF;
    border-radius: 8px;
    margin: 0px auto;
    width: 952px;
    padding: 0 24px;
    box-sizing: border-box;
    .content_header{
      display: flex;
      font-size: 14px;
      .content_header_h{
        color: #9499A4;
        margin-right: 8px;
      }
    }
    .content_box{
      min-height: 456px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team-message/notice-info.vue